import Marquee from "react-fast-marquee";
import { Reveal } from "@/components/Reveal";

const roles = ["Corporate Training", "Coworking Solutions", "F&B Franchising", "Mentorship & Speaking"];

const rowA = ["IT Training", "Skill Development", "Placement", "Lead Generation", "Online Marketing", "Content Writing", "Google Ads", "Web Development"];
const rowB = ["Real Estate", "Community Building", "Food Retail", "Franchise Ops", "Branding", "Strategy", "Team & Culture", "Business Development"];

export const Expertise = () => (
  <section id="expertise" className="relative bg-[#121110] text-[#EFEAE1] py-28 lg:py-36 overflow-hidden" data-testid="expertise-section">
    <div className="px-5 lg:px-10">
      <Reveal>
        <h2 className="font-giant text-[12vw] lg:text-[7.5vw] leading-[0.9]">
          Y<span className="font-swash text-[#A8512E] text-[10vw] lg:text-[6vw]">ou</span>R IDEA{" "}
          <span className="font-swash text-[#A8512E] text-[10vw] lg:text-[6vw]">x</span> 10?
        </h2>
      </Reveal>

      <Reveal delay={0.1}>
        <div className="grid grid-cols-2 lg:grid-cols-4 mt-16 border-t border-[#EFEAE1]/20">
          {roles.map((r, i) => (
            <div key={r} className={`py-8 pr-6 ${i > 0 ? "lg:border-l lg:border-[#EFEAE1]/20 lg:pl-8" : ""}`} data-testid={`expertise-role-${i}`}>
              <p className="text-lg lg:text-xl text-[#EFEAE1]/80">{r}</p>
            </div>
          ))}
        </div>
      </Reveal>

      <Reveal delay={0.15}>
        <p className="max-w-2xl text-lg lg:text-xl leading-relaxed text-[#EFEAE1]/70 mt-10">
          The experience and network I've built across three verticals are things I enjoy
          putting to work. I collaborate with driven people on a <strong className="text-[#EFEAE1]">value-first approach</strong> —
          we get to know each other, focus on impact, and aim long-term. If you reach out,
          I'll happily tell you more.
        </p>
      </Reveal>
    </div>

    <div className="mt-20 space-y-5">
      <Marquee speed={38} gradient={false} autoFill>
        {rowA.map((t) => (
          <span key={t} className="chip">{t}</span>
        ))}
      </Marquee>
      <Marquee speed={38} gradient={false} autoFill direction="right">
        {rowB.map((t) => (
          <span key={t} className="chip">{t}</span>
        ))}
      </Marquee>
    </div>
  </section>
);

export default Expertise;
